<template lang="pug">
  ModalReveal(ref="terminateModal")
    button.button(slot="trigger" style="color:#A3A3A3" ) Terminate
    h2 Terminate reservation R{{entity.number}}
    label Accept undesirable zone
    input-switch(v-model="terminateBody.acceptUndesiderable")
    template(v-if="!configuration.constraints.constraints_forbid_to_end_in_forbidden.value" )
      label Force forbidden zone
      input-switch(v-model="terminateBody.forceForbidden", :disabled="true")
    ActionButton(:action="terminate" slot="footer" ) Terminate
</template>
<script>
import ActionButton from '../ActionButton'
import InputSwitch from "../InputSwitch.vue"
import ModalReveal from '../../foundation/ModalReveal'
import KeplerBackofficeSdk from "../../../../lib/kepler/backoffice";
import MaggieHelper from "../../../../maggieHelper";
import {mapState} from "vuex";

export default {
  name: 'TerminateReservationReveal',
  components: {ActionButton, InputSwitch, ModalReveal},

  data() {
    return {
      terminateBody: {
        acceptUndesiderable: false,
        forceForbidden: false,
      }
    }
  },
  methods: {
    terminate() {
      return KeplerBackofficeSdk.reservations.select(this.entity.number).terminate(this.terminateBody, function () {
        MaggieHelper.notification('terminate-esit', 'reservation ended')
        this.$refs.terminateModal.close()
      })
    },
  },
  props: {
    entity: {},
  },
  computed:{
    ...mapState({
      configuration: state => state.configuration,
    }),
  }
}
</script>



// WEBPACK FOOTER //
// TerminateReservationReveal.vue?2a78a818